import React, { useEffect, useState } from 'react'
import { NodeViewContent, NodeViewWrapper } from '@tiptap/react'
import { observer } from 'mobx-react-lite'
import { Duration } from 'luxon'

import { matchCitations } from '@trivie/core/src/utils/matchCitations'

import { Citation } from '../../citation'
import { color } from '@trivie/ui-web/theme'

export const ParagraphNode = observer((props: any) => {
  const { quiz, selectTimestamp, selectQuestion } = props.extension.options

  const [hoverTimestamp, setHoverTimestamp] = useState(false)
  const [citations, setCitations] = useState<any>([])

  useEffect(() => {
    setCitations(
      matchCitations(
        props.node.attrs.generated_question_ids,
        quiz?.questions?.filter((q) => !q.removing),
      ),
    )
  }, [
    props.node.attrs?.generated_question_ids,
    quiz?.questions?.filter((q) => !q.removing)?.length,
  ])

  const onCitationClick = (citation) =>
    selectQuestion(quiz.questions.find((q) => q.generated_question_id === citation.gqid))

  const { start_millisecond, end_millisecond } = props.node.attrs
  const timestamp =
    Boolean(start_millisecond) && Boolean(end_millisecond)
      ? `[${Duration.fromObject({ milliseconds: start_millisecond }).toFormat('hh:mm:ss')}]`
      : ''

  const played = Number(quiz?.mercuryResource?.progress?.playedSeconds) * 1000
  const activeTimestamp =
    Boolean(start_millisecond) &&
    Boolean(end_millisecond) &&
    played >= start_millisecond &&
    played <= end_millisecond

  return (
    <NodeViewWrapper>
      {timestamp && (
        <span
          onMouseEnter={() => setHoverTimestamp(true)}
          onMouseLeave={() => setHoverTimestamp(false)}
          style={{
            userSelect: 'none',
            fontWeight: 600,
            marginRight: 4,
            transition: 'color .3s ease-in-out',
            color: activeTimestamp ? color.blue : '#000',
            textDecoration: hoverTimestamp ? 'underline' : 'none',
            cursor: hoverTimestamp ? 'pointer' : 'none',
          }}
          onClick={() => selectTimestamp(props.node.attrs?.start_millisecond)}
        >
          {timestamp}
        </span>
      )}
      <NodeViewContent
        style={{
          transition: 'color .3s ease-in-out',
          // fontWeight: activeTimestamp ? 600 : 400,
          color: activeTimestamp ? color.blue : '#000',
        }}
        key="par-node-content"
        as="span"
        {...props.node.attrs}
        className="paragraph-node-content"
      />
      <span>
        {citations
          ?.sort((a, b) => a?.level - b?.level)
          ?.map((citation) => (
            <Citation
              elementType="p"
              onClick={() => onCitationClick(citation)}
              citation={citation}
            />
          ))}
      </span>
    </NodeViewWrapper>
  )
})
